import { PROJECT_STATUSES } from "@/app/projects/constants";
import { StatusCell } from "@/components/status-cell";

const props = {
  [PROJECT_STATUSES.succeeded]: { label: "Processed", variant: "success" },
  [PROJECT_STATUSES.failed]: { label: "Error", variant: "error" },
  [PROJECT_STATUSES.notStarted]: {
    label: "Not started",
    variant: "not_started",
  },
  [PROJECT_STATUSES.processing]: { label: "Processing", variant: "processing" },
};

export const ProjectStatusCell = ({ status }) => {
  return (
    <StatusCell label={props[status].label} variant={props[status].variant} />
  );
};
